module.exports = __webpack_public_path__ + "media/images/lb/485-9d7e730a767374d1e5f9b5df1b114074.svg";